import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b192248"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert__wrapper"
}

import { computed, ref, watch } from 'vue';
import alertStore from '@/applets/common/AlertStore';

/*
Visual control of the alert
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertNotification',
  setup(__props) {

const visible = ref(false);
const persistent = ref(false);
const isFlashing = ref(false);

function hide(): void {
  persistent.value = false;
  visible.value = false;
}

function unflash(): void {
  isFlashing.value = false;
}

const classes = computed((): Record<string, boolean> => ({
  'alert--persistent': persistent.value,
  'alert--flash': isFlashing.value,
  'alert--error': true,
}));

/*
Timing of the alert
*/

const timeout = ref(setTimeout(hide, 5000));

function cancelAutoHide(): void {
  persistent.value = true;
  clearTimeout(timeout.value);
}

/*
Logic to set up a new alert
*/

const message = ref('');

function newAlert(): void {
  const newMessage = alertStore.getMessage;

  if (newMessage === '') return;

  // If the alert is already visible, trigger a isFlashing
  if (visible.value) {
    // Set new isFlashing timeout, but not if waiting for the last one
    if (!isFlashing.value) setTimeout(unflash, 250);
    isFlashing.value = true;
  }
  message.value = newMessage;
  visible.value = true;

  // Cancel last timeout and set a new (extended) one
  clearTimeout(timeout.value);
  if (!persistent.value) timeout.value = setTimeout(hide, 5000);
}

watch(alertStore, newAlert);


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["alert", _unref(classes)]),
              onMouseover: cancelAutoHide,
              onFocus: cancelAutoHide
            }, [
              _createElementVNode("span", null, _toDisplayString(message.value), 1),
              _createVNode(_component_font_awesome_icon, {
                icon: "xmark",
                class: "alert__closebtn",
                onClick: hide
              })
            ], 34)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})